import { BLOCKING_STATUS_UPDATED, REQUEST_COUNT_UPDATED } from "../Constants";

export function toggleBlockingStatus(status) {
    return {
        type: BLOCKING_STATUS_UPDATED,
        payload: status
    };
}

export function updateRequestCount(increase) {
    return {
        type: REQUEST_COUNT_UPDATED,
        payload: increase
    };
}